import { render } from "./videoAccessTemplate.vue?vue&type=template&id=3635c2e0&scoped=true"
import script from "./videoAccessTemplate.vue?vue&type=script&lang=js"
export * from "./videoAccessTemplate.vue?vue&type=script&lang=js"

import "./videoAccessTemplate.vue?vue&type=style&index=0&id=3635c2e0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3635c2e0"]])

export default __exports__